// Returns the total visible height of the bars above the sticky header
// (announcement bar, USP bar, delivery country bar). Bars scrolled fully out of
// the viewport are excluded; partially visible bars contribute only their visible
// portion via Math.min(rect.height, rect.bottom).
export function measureBarsHeight(): number {
  return Array.from(
    document.querySelectorAll<HTMLElement>(
      '.delivery-country-selection-topbar, .header-announcement-bar, .section-usp',
    ),
  ).reduce((sum, el) => {
    const style = getComputedStyle(el)
    if (style.display === 'none' || style.visibility === 'hidden') return sum
    const rect = el.getBoundingClientRect()
    if (rect.bottom <= 0) return sum
    return sum + Math.min(rect.height, rect.bottom)
  }, 0)
}
